import { useState } from "react";
import { Button, CloseButton, Modal } from "react-bootstrap";
import {
  AiFillCheckCircle,
  AiFillCloseCircle
} from "react-icons/ai";
import { FaCircleExclamation } from "react-icons/fa6";

const FileViewModal = ({ show, onHide, title, fileLink }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <iframe
            src={fileLink}
            title={title}
            width="100%"
            height="700px"
            frameBorder="0"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileViewModal;

export function PopUpModalButton({ title, fileLink, variant }) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <Button variant={variant}
        className=" text-nowrap px-2 py-1 text-white rounded small-font"
        onClick={() => setModalShow(true)}
      >
        {title}
      </Button>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="xl"
        centered
      >
        <Modal.Header
          style={{ backgroundColor: "#0b3b5d", color: "white" }}
          className="text-white"
        >
          <Modal.Title>{title}</Modal.Title>

          <CloseButton variant="white" onClick={() => setModalShow(false)} />
        </Modal.Header>{" "}
        <Modal.Body>
          <div>
            <iframe
              src={fileLink}
              title={title}
              width="100%"
              height="700px"
              frameBorder="0"
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export function AdvancedPopUpModalButton({ title, fileLink, variant }) {
  const [modalShow, setModalShow] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  const isImage = fileLink?.match(/\.(jpeg|jpg|gif|png|webp)$/i);

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 0.2, 0.5));
  const handleRotate = () => setRotation(prev => (prev + 90) % 360);
  const handleReset = () => {
    setZoom(1);
    setRotation(0);
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(fileLink);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileLink.split('/').pop() || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
      window.open(fileLink, '_blank');
    }
  };

  return (
    <>
      <Button variant={variant}
        className=" text-nowrap px-2 py-1 text-white rounded small-font"
        onClick={() => {
          setModalShow(true);
          handleReset();
        }}
      >
        {title}
      </Button>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="xl"
        centered
      >
        <Modal.Header
          style={{ backgroundColor: "#0b3b5d", color: "white" }}
          className="text-white d-flex justify-content-between align-items-center w-100"
        >
          <Modal.Title>{title}</Modal.Title>
          <div className="d-flex gap-2 align-items-center">
            {isImage && (
              <>
                <Button variant="outline-light" size="sm" onClick={handleZoomIn}>Zoom In</Button>
                <Button variant="outline-light" size="sm" onClick={handleZoomOut}>Zoom Out</Button>
                <Button variant="outline-light" size="sm" onClick={handleRotate}>Rotate</Button>
                <Button variant="outline-light" size="sm" onClick={handleReset}>Reset</Button>
              </>
            )}
            <Button variant="outline-light" size="sm" onClick={handleDownload}>Download</Button>
            <CloseButton variant="white" onClick={() => setModalShow(false)} />
          </div>
        </Modal.Header>
        <Modal.Body className="p-0 overflow-hidden" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "75vh", overflow: "auto" }}>
            {isImage ? (
              <div style={{ 
                transition: "transform 0.3s ease",
                transform: `scale(${zoom}) rotate(${rotation}deg)`,
                display: "inline-block"
              }}>
                <img 
                  src={fileLink} 
                  alt={title} 
                  style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }} 
                />
              </div>
            ) : (
              <iframe
                src={fileLink}
                title={title}
                width="100%"
                height="750px"
                frameBorder="0"
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export function PopUpModalLink({ title, fileLink, className, style }) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <button
        type="button"
        className={className}
        style={{ background: "none", border: "none", padding: 0, ...style, color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
        onClick={() => setModalShow(true)}
      >
        {title}
      </button>

      <Modal show={modalShow} onHide={() => setModalShow(false)} size="xl" centered>
        <Modal.Header
          style={{ backgroundColor: "#0b3b5d", color: "white" }}
          className="text-white"
        >
          <Modal.Title>{title}</Modal.Title>
          <CloseButton variant="white" onClick={() => setModalShow(false)} />
        </Modal.Header>
        <Modal.Body>
          <div>
            <iframe src={fileLink} title={title} width="100%" height="700px" frameBorder="0" />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

//are you sure popup modal

export function ConfirmModal({ handleApproveRejectEco, userId }) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <Button
        className="m-0 p-0 border-none"
        style={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <AiFillCheckCircle
          className="w-100 icon-size green-color"
          onClick={() => setModalShow(true)}
        />
      </Button>
      <Button
        className="m-0 p-0 border-none"
        style={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <AiFillCloseCircle
          className="w-100 icon-size text-danger"
          onClick={() => setModalShow(true)}
          // onClick={() => handleApproveRejectEco(data._id, false)}
        />
      </Button>

      <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
        <div className="text-end">
          <CloseButton
            onClick={() => setModalShow(false)}
            className="m-3 mb-0 pb-0"
          />
        </div>

        <Modal.Body className="pt-0">
          <div className="text-center">
            <FaCircleExclamation
              style={{ color: "#0b3b5d", fontSize: "8rem" }}
            />

            <h4 className="text-info mb-4 mt-2">
              Are you sure you want to proceed?
            </h4>

            <div className="d-flex justify-content-center gap-3">
              <Button
                variant="success"
                className="px-5"
                onClick={() => handleApproveRejectEco(userId, true)}
              >
                Accept
              </Button>
              <Button
                variant="danger"
                className="px-5"
                onClick={() => handleApproveRejectEco(userId, false)}
              >
                Reject
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}


export function PaymentConfirmModal({
  handleUpdateRejectAddFund,
  disabled,
  clientId,
  userId,
  paymentId,
  appNo,
}) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <Button
        className="m-0 p-0 border-none"
        style={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <AiFillCheckCircle
          className="w-100 icon-size green-color"
          onClick={() => setModalShow(true)}
        />
      </Button>
      <Button
        className="m-0 p-0 border-none"
        style={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <AiFillCloseCircle
          className="w-100 icon-size text-danger"
          onClick={() => setModalShow(true)}
        />
      </Button>

      <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
        <div className="text-end">
          <CloseButton
            onClick={() => setModalShow(false)}
            className="m-3 mb-0 pb-0"
          />
        </div>

        <Modal.Body className="pt-0">
          <div className="text-center">
            <FaCircleExclamation style={{ color: "#0b3b5d", fontSize: "8rem" }} />

            <h4 className="text-info mb-4 mt-2">
              Are you sure you want to proceed?
            </h4>

            <div className="d-flex justify-content-center gap-3">
              <Button
                variant="success"
                className="px-5"
                onClick={() =>
                  handleUpdateRejectAddFund(clientId, userId, true, appNo, paymentId)
                }
                disabled={disabled}
              >
                {disabled ? `loading..` : `Accept`}
              </Button>
              <Button
                variant="danger"
                className="px-5"
                onClick={() =>
                  handleUpdateRejectAddFund(clientId, userId, false, appNo, paymentId)
                }
              >
                Reject
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}


//simple modla as per body
export function PopUpModalPriceRecord({ title, updateListData }) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      {/* <FcAnswers
        className="ms-2 icon-size cursor-pointer"
        onClick={() => setModalShow(true)}
      /> */}
      <h6 className="cursor-pointer" onClick={() => setModalShow(true)}>
        {title}
      </h6>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        centered
      >
        <Modal.Body>
          <h4 className="mb-4">Date And Time : {title}</h4>
          <div className="d-flex justify-content-between">
            <div>
              <h5>Eco Pricing</h5>
              <h6 className="no-wrap">Eco Price: {updateListData.eco}</h6>
              <h6 className="no-wrap">
                Commercial Invoice: {updateListData.comInvoiceEco}
              </h6>
              <h6 className="no-wrap">
                Packing List: {updateListData.packListEco}
              </h6>
              <h6 className="no-wrap">
                Additional Document: {updateListData.addDocEco}
              </h6>
              <h6 className="no-wrap">
                Processing Charges: {updateListData.ecoPc}
              </h6>
            </div>
            <div>
              <h5>Semi-Eco Pricing</h5>
              <h6 className="no-wrap">Eco Price: {updateListData.semiEco}</h6>
              <h6 className="no-wrap">
                Commercial Invoice: {updateListData.comInvoiceMco}
              </h6>
              <h6 className="no-wrap">
                Packing List: {updateListData.packListMco}
              </h6>
              <h6 className="no-wrap">
                Additional Document: {updateListData.addDocMco}
              </h6>
              <h6 className="no-wrap">
                Intercity/Gujrat: {updateListData.interGujDelMode}
              </h6>
              <h6 className="no-wrap">
                Pan India: {updateListData.panIndDelMode}
              </h6>
              <h6 className="no-wrap">Semi-ECO(PC): {updateListData.mcoPc}</h6>
              <h6 className="no-wrap">
                Commercial Invoice (PC): {updateListData.mcoComInvoicePc}
              </h6>{" "}
              <h6 className="no-wrap">
                Packing List (PC): {updateListData.mcoPackListPc}
              </h6>{" "}
              <h6 className="no-wrap">
                Additional Document (PC): {updateListData.mcoAddDocPc}
              </h6>
            </div>
            <div>
              <h5>Non-Standard Pricing</h5>
              <h6 className="no-wrap">
                A. Commercial Document: {updateListData.A_ComDoc}
              </h6>
              <h6 className="no-wrap">
                B. MCA Document: {updateListData.B_McaDoc}
              </h6>
              <h6 className="no-wrap">
                C. Export Permission related Document: {updateListData.C_ExpDoc}
              </h6>
              <h6 className="no-wrap">
                D. Pharma Reg. Documents: {updateListData.D_PharmDoc}
              </h6>
              <h6 className="no-wrap">
                E. Agro Chemical: {updateListData.E_AgroDoc}
              </h6>{" "}
              <h6 className="no-wrap">
                F. Other document: {updateListData.F_OtherDoc}
              </h6>{" "}
              <h6 className="no-wrap">
                Processing Charges: {updateListData.nonStandPc}
              </h6>
            </div>
          </div>
          <CloseButton
            variant="danger"
            className="position-absolute top-0 end-0 mt-4 me-4"
            onClick={() => setModalShow(false)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
